module.exports = __webpack_public_path__ + "static/portfolio_hiro4-fs8-a5400aa7d307c15a20f3b51a71708709.png";